import type { ReactNode } from 'react';

import { useAgencyConfiguration } from './AgencyConfigurationContext';

export type AgencyViewProps = {
  agencyId?: string;
  agencyIds?: string[];
  children?: ReactNode;
};

export function AgencyView({ agencyId, agencyIds, children }: AgencyViewProps) {
  const agencyConfiguration = useAgencyConfiguration();

  const effectiveAgencyIds =
    agencyIds != null
      ? agencyId != null
        ? [...agencyIds, agencyId]
        : agencyIds
      : agencyId != null
        ? [agencyId]
        : (() => {
            throw new Error('At least one of the parameters agencyId or agencyIds must be set.');
          })();

  const isVisible =
    agencyConfiguration != null && effectiveAgencyIds.includes(agencyConfiguration.id);

  return isVisible ? <>{children}</> : null;
}
